import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/bmr-calculator/pages/CalculatorPage";

export const Route = createFileRoute("/bmr-calculator")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/bmr-calculator",
      title: m.bmr_meta_title(),
      description: m.bmr_meta_description(),
      toolName: m.bmr_tool_name(),
      faqs: [
        { q: m.bmr_faq_q1(), a: m.bmr_faq_a1() },
        { q: m.bmr_faq_q2(), a: m.bmr_faq_a2() },
        { q: m.bmr_faq_q3(), a: m.bmr_faq_a3() },
        { q: m.bmr_faq_q4(), a: m.bmr_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
